import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './IntroducedInvestorRegistration.scss';
import { CompactHeader } from '../../../components/CompactHeader/CompactHeader';
import { CompactFooter } from '../../../components/CompactFooter/CompactFooter';

/**
 * Success Page after registration completion
 * Shows registration complete message and login link
 */
const IntroducedInvestorSuccess: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  // azureUserId is the B2C object id; present only when the account was created, and it is
  // what /investor/setpassword/:azureUserId expects.
  const state = location.state as {
    message?: string;
    b2cCreated?: boolean;
    azureUserId?: string;
  } || {};

  return (
    <>
      <CompactHeader />
      <section className="login-form-style4 section-padding">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-7 col-md-10 col-sm-12">
              <div className="login-form-style3-main">
                <div className="login-form-style3-main_full">
                  <div className="login-register_style3-head">
                    <h2>Registration Successful!</h2>
                  </div>

                  <div className="login-register3-form-middle" style={{ textAlign: 'center' }}>
                    <div style={{ padding: '16px 0' }}>
                      <div style={{ marginBottom: '16px' }}>
                        <svg
                          width="60"
                          height="60"
                          viewBox="0 0 80 80"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{ display: 'inline-block' }}
                        >
                          <circle cx="40" cy="40" r="40" fill="#28a745" />
                          <path
                            d="M25 40L35 50L55 30"
                            stroke="white"
                            strokeWidth="5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </div>

                      <h3 style={{ color: '#28a745', marginBottom: '12px', fontSize: '16px', fontWeight: 'bold' }}>
                        Thank You for Registering with Facilon Services!
                      </h3>

                      {state.b2cCreated !== false && (
                        <>
                          {/* No password is ever emailed — the message is "Facilon - Set Your
                              Password" and carries a one-time link the investor uses to choose
                              their own. Saying "login credentials have been sent" made people
                              look for a password that was never there. */}
                          <p style={{ fontSize: '13px', color: '#475569', marginBottom: '8px' }}>
                            Your registration has been completed successfully.
                          </p>
                          <p style={{ fontSize: '13px', color: '#475569', marginBottom: '8px' }}>
                            <strong>We&rsquo;ve emailed you a link to set your password.</strong>
                          </p>
                          <p style={{ fontSize: '12px', color: '#64748b', marginBottom: '16px' }}>
                            Open the email titled <strong>&ldquo;Facilon &ndash; Set Your Password&rdquo;</strong> and
                            click <strong>Set Your Password</strong> to choose your password, then sign in with
                            your email address. If it isn&rsquo;t in your inbox, please check your spam folder.
                          </p>
                        </>
                      )}

                      {state.b2cCreated === false && (
                        <>
                          <p style={{ fontSize: '13px', color: '#475569', marginBottom: '8px' }}>
                            Your registration has been completed, but there was an issue creating your login account.
                          </p>
                          <p style={{ fontSize: '13px', color: '#3e6f7c', marginBottom: '16px', fontWeight: '600' }}>
                            Please contact support at support@facilonservices.com
                          </p>
                        </>
                      )}

                      {/* The emailed link points at this same page, so offering it here just
                          saves the investor a trip to their inbox.

                          Login is offered ONLY as the fallback when there is no azureUserId to
                          set a password with. Beside "Set Your Password" it was a dead end: the
                          account has no password yet, so anyone taking it would land on /login
                          unable to sign in. */}
                      {(() => {
                        const canSetPassword = state.b2cCreated !== false && !!state.azureUserId;
                        return (
                          <div style={{ marginTop: '24px', display: 'flex', gap: '12px',
                                        justifyContent: 'center', flexWrap: 'wrap' }}>
                            {canSetPassword ? (
                              <button
                                className="button-1"
                                onClick={() => navigate(`/investor/setpassword/${state.azureUserId}`)}
                                style={{ display: 'inline-block' }}
                              >
                                Set Your Password
                              </button>
                            ) : (
                              <button
                                className="button-1"
                                onClick={() => navigate('/login')}
                                style={{ display: 'inline-block' }}
                              >
                                Proceed to Login
                              </button>
                            )}
                          </div>
                        );
                      })()}

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <CompactFooter />
    </>
  );
};

export default IntroducedInvestorSuccess;
